// Signing identities kept in this browser: a certificate and its private key (stored as a non-extractable key, so the key itself can
// never be read back out of the browser, only used to sign).

import type { SigningIdentity } from "@fg/web-core/pdf";

const DB = "fg.signing";
const STORE = "identities";

function open(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const r = indexedDB.open(DB, 1);
        r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: "created" });
        r.onsuccess = () => resolve(r.result);
        r.onerror = () => reject(r.error ?? new Error("The browser's storage is not available."));
    });
}

const run = async <T,>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> => {
    const db = await open();
    return new Promise<T>((resolve, reject) => {
        const tx = db.transaction(STORE, mode);
        const req = fn(tx.objectStore(STORE));
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
        tx.oncomplete = () => db.close();
    });
};

export const listIdentities = (): Promise<SigningIdentity[]> => run("readonly", (s) => s.getAll() as IDBRequest<SigningIdentity[]>).then((l) => l.sort((a, b) => a.created - b.created)).catch(() => []);
export const saveIdentity = (id: SigningIdentity): Promise<unknown> => run("readwrite", (s) => s.put(id));
export const deleteIdentity = (created: number): Promise<unknown> => run("readwrite", (s) => s.delete(created));
